// removed by extract-text-webpack-plugin
module.exports = {"component":"_2BIGd6EQfn_M_1tkqnAZmW","container":"_3MEdQ2rcoQI8OkAL_P9K-K","backButton":"_3ItikNiw40qwFISSN0AiUp","label":"Y8ciQ2SHGYvhmWR6DRWr7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BaseBackButton/BaseBackButton.css
// module id = 1296
// module chunks = 0